import { BlobServiceClient } from "@azure/storage-blob";

import { authProvider } from '../utils/authProvider';
export default class BlobUtil{
    account:string = "ultimatesprodevstorage01";
    sas:string = ""; 
    containerName:string ="";
    blobServiceClient:any;
    uploadSizeBytes:number = 0;
    uploadedBytes:number = 0;
    /**
     *
    constructor() {
      //let accountInfo = authProvider.getAccountInfo();
      //console.log(accountInfo?.jwtIdToken);
      // fetch("https://ultimatesprodevapi01.azurewebsites.net/api/GetUserFaceBlobContainerSAS?code=Up5ZaGypEo2I0FMqvUCKDAM1PcIaFXMLWsVn6kjbP8xwGinljjxxtw==",
      //   {method:"get",
      //   headers:new Headers({
      //     "Authorization":"Bearer " + accountInfo?.jwtIdToken,
      //     "Content-Type":"application/json"
      //   })}
      // ).then(
      //   data =>{

      //     console.log(data);
      //     data.text().then( (sas2:any)=>{
      //       this.containerName = "user-" + accountInfo?.account.accountIdentifier;
      //       //console.log(sas2);
      //       this.sas = sas2;
      //       this.blobServiceClient = new BlobServiceClient(`https://${this.account}.blob.core.windows.net?${sas2}`            );
      //     })
      //   } 
      // );
    } 

     */
    public async GenerateSARSToken():Promise<string>{
      let accountInfo = authProvider.getAccountInfo();
      if (this.sas != ''){
        return this.sas;
      }else{
        return await fetch("https://ultimatesprodevapi03.azurewebsites.net/api/GenerateSasToken?code=HSxY8YYlOsxBisePL5kz7BLD6hJt7xq4GOIw18Re8ChpnZxbnPxGZw==",
          {method:"get",
          headers:new Headers({
            "Authorization":"Bearer " + accountInfo?.jwtIdToken,
            "Content-Type":"application/json"
          })}
        ).then(
          data =>{
            console.log(data);
            return data.text().then( 
              (sas2:any)=>{
              this.containerName = "user-" + accountInfo?.account.accountIdentifier;
              //console.log(sas2);
              this.sas = sas2;
              const _url = "https://" +this.account + ".blob.core.windows.net?" +this.sas;
              this.blobServiceClient = new BlobServiceClient(_url);
              
              return this.sas;
            });
          } 
        );
      }
    }
    
    
    public async Upload(filename:string,content:any, metadata?:any):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();

        let containerClient = this.blobServiceClient.getContainerClient(this.containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        //blockBlobClient.Properties.ContentType = "image/png";
        let uploadBlobResponse = await blockBlobClient.upload(content,content.length,{
          blobHTTPHeaders: {blobContentType:"image/jpg"

            },
          metadata: metadata === undefined ?{}:metadata
        });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
        console.log(error);
          throw error;
      }
    }

    public async UploadBlob(filename:string,content:any,contentType:string , metadata?:any ):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();

        let containerClient = this.blobServiceClient.getContainerClient(this.containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        //blockBlobClient.Properties.ContentType = "image/png";
        let uploadBlobResponse = await blockBlobClient.uploadBrowserData(content,{
          blobHTTPHeaders: {blobContentType:contentType

          },
          metadata: metadata === undefined ?{}:metadata
        });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
        console.log(error);
          throw error;
      }
    }

    
    public async UploadBlobToCointainer(filename:string,content:any,contentType:string, containerName:string, metadata?:any ):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();

        let containerClient = this.blobServiceClient.getContainerClient(containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        //blockBlobClient.Properties.ContentType = "image/png";
        let uploadBlobResponse = await blockBlobClient.uploadBrowserData(content,{
          blobHTTPHeaders: {blobContentType:contentType

          },
          metadata: metadata === undefined ?{}:metadata
        });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
        console.log(error);
          throw error;
      }
    }

     
    public async UploadBlobToCointainer3(filename:string, content:any, 
      containerName:string, metadata?:any ):Promise<string> {
      try {
        await this.GenerateSARSToken();
        this.uploadedBytes = 0;
        let containerClient = this.blobServiceClient.getContainerClient(containerName);
        let blockBlobClient  = containerClient.getBlockBlobClient(filename);
        let contentType = content.type;
        this.uploadSizeBytes = content.size;
        let uploadBlobResponse = await blockBlobClient.uploadBrowserData(content,
          {
            blockSize: 4 * 1024 * 1024, // 4MB block size
            concurrency: 20, // 20 concurrency
            onProgress: (ev:any) => 
              {
                //console.log("Uploading.." + ev.loadedBytes) 
                this.uploadedBytes = ev.loadedBytes;
              }
            ,
            blobHTTPHeaders: {blobContentType:contentType}
          });
        return uploadBlobResponse._response.request.url;
  
      } catch (error) {
        console.log(error);
          throw error;
      }
    }

    public getUploadProgress(){
      let uploadedPercentage = this.uploadedBytes / this.uploadSizeBytes * 100
      return Number(uploadedPercentage.toFixed(2));
    }


    public async GetBlob(oId:string, filename:string):Promise<string> {
      try {
        let blobSarsToken = await this.GenerateSARSToken();
        let accountInfo = authProvider.getAccountInfo();
        //var containerName = "user-" + accountInfo?.account.accountIdentifier;
        var containerName = "user-" + oId;
        
        return `https://${this.account}.blob.core.windows.net/${containerName}/${filename}${this.sas}`;

      } catch (error) {
          console.log(error);
          throw error;
      }
    }

    
    public async GetBlob2(containerName:string, filename:string):Promise<string> {
      try {
        await this.GenerateSARSToken();
        // let accountInfo = authProvider.getAccountInfo();
        //var containerName = "user-" + accountInfo?.account.accountIdentifier;
        
        return `https://${this.account}.blob.core.windows.net/${containerName}/${filename}${this.sas}`;

      } catch (error) {
          console.log(error);
          throw error;
      }
    }
}



